export default __webpack_public_path__ + "static/profile-af631f34b87d5d911c402b73d371a299.jpg";